import { FieldRendererProps } from "../fieldRenderersEditors";
import StringFieldRenderer, { StringFieldRendererProps } from "./StringFieldRenderer";
import { Optional } from "@crispico/foundation-react";
import { Messages, FilterOperators } from "@crispico/foundation-gwt-js";
import { FieldDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { FieldInterval } from "@crispico/foundation-react/entity_crud/CrudSettings";
import { NavLink } from "react-router-dom";
import { ShareLinkLogic } from "../ShareLinkLogic";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";

export class DropdownFieldRenderer extends StringFieldRenderer<StringFieldRendererProps> {

    protected getText() {
        const { fieldDescriptor, value } = this.props;
        const fi = fieldDescriptor.getFieldInterval(value);
        return fi ? this.getDropdownLabel(fi) : value;
    }

    getDropdownLabel(fi: FieldInterval): any {
        return getDropdownItemLabel(this.props.fieldDescriptor, fi)
    }

    render() {
        const content = super.render();
        const { props } = this;

        let url = undefined;
        if (props.value && props.asLabel) {
            url = new ShareLinkLogic().createLink(false, props.fieldDescriptor.parent, Filter.enableAllFilters(Filter.create(props.fieldDescriptor.name, FilterOperators.forString.equals, props.value)));
        }
        return url ? <NavLink to={url}>{content}</NavLink> : content;
    }
}
// );

export function getDropdownItemLabel(fieldDescriptor: FieldDescriptor | undefined, fieldInterval: FieldInterval): string {
    let label: Optional<string> =
        _msg({ missingKeyStrategy: "RETURN_NULL" }, [fieldDescriptor?.parent?.name, fieldDescriptor?.nameBeforeCopyToFilter || fieldDescriptor?.name, fieldInterval.from].join(".")) ||
        _msg({ missingKeyStrategy: "RETURN_NULL" }, [fieldDescriptor?.parent?.name, fieldDescriptor?.nameBeforeCopyToFilter || fieldDescriptor?.name, fieldInterval.enumOrderIndex].join(","));
    if (!label) {
        label = fieldInterval.label;
    }
    if (label) {
        label = Messages.getInstance().maybeTranslateByUser(label);
    }
    if (!label) {
        label = fieldInterval.from;
    }
    return label;

}"../..""../EntityDescriptor""../CrudSettings""../../components/CustomQuery/Filter"